import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import { round } from 'mathjs';

import './scss/table.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moJob from './store';
import moIndex from '../store/index';
import TableHead from './table-head';

interface IProps {
  list: any[];
}
interface IState {}

const Table = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry } = moIndex;
  const { list } = props;

  useEffect(() => {
    return () => {};
  }, []);

  const locateValue = (value: any) => {
    if (isNaN(value)) return '-';
    if (value === null || value === '' || value === undefined) return '-';
    return Number(round(value / 10000, 1)).toLocaleString();
  };

  return (
    <section className="table-1616">
      <TableHead />

      <section className="content-1616">
        {list.map((item: any, index: number) => (
          <section key={index} className="content-160">
            <strong className="industry-1011">{item.industry}</strong>

            <section className="content-170">
              {item.arr?.map((child: any, idx: number) => (
                <section key={idx} className="content-190">
                  <strong className="category-1011">{child.category}</strong>
                  <strong className="position-1011">{child.position}</strong>
                  <section className="line-166166">
                    <p className="line-166">
                      <i className="value-11">{locateValue(child.fix10)}</i>
                      <i className="value-12">{locateValue(child.fix50)}</i>
                      <i className="value-13">{locateValue(child.fix90)}</i>
                    </p>
                    <p className="line-166">
                      <i className="value-11">{locateValue(child.tcc10)}</i>
                      <i className="value-12">{locateValue(child.tcc50)}</i>
                      <i className="value-13">{locateValue(child.tcc90)}</i>
                    </p>
                  </section>
                </section>
              ))}
            </section>
          </section>
        ))}
      </section>
    </section>
  );
};

export default observer(Table);
